import { getToken, getUser, formatDateYMD, removeCommas } from "../../Utilities/Common";
import {
  getWithParamsAPICall,
  postAPICall,
  postAPICallwithFile,
} from "../axiosMethodCall";

export const getListOfSales = async (params) => {
  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      ...params,
    };

    const response = await getWithParamsAPICall(
      process.env.REACT_APP_LINK + "sales/get",
      payload
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const createSales = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("inventory_id", data.inventory_id);
    formData.append("patient_name", data.patient_name);
    formData.append("sales_date", data.sales_date);
    formData.append("unit_price", data.unit_price);
    formData.append("quantity", data.quantity);
    formData.append("remarks", data.remarks);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "sales/create",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateSales = async (data) => {
  const currentDate = Date();
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("sale_id", data.id);
    formData.append("patient_name", data.patient_name);
    formData.append("inventory_id", data.inventory_id);
    formData.append("unit_price", removeCommas(data.unit_price));
    formData.append("sales_date", formatDateYMD(currentDate));
    formData.append("quantity", data.quantity);
    formData.append("remarks", data.remarks);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "sales/update",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const deleteSales = async (sale_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "sales/delete",
      {
        requester: getUser(),
        token: getToken(),
        sale_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

/**
 * Inventory
 */
export const createItem = async (data) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("item", data.item);
    formData.append("description", data.description);
    formData.append("unit_price", data.unit_price);
    formData.append("stock", data.stock);
    formData.append("beginning_inventory", data.stock);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "inventories/create",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const updateItem = async (data, inventory) => {
  try {
    var formData = new FormData();
    formData.append("requester", getUser());
    formData.append("token", getToken());
    formData.append("inventory_id", inventory.id);
    formData.append("item", inventory.item);
    formData.append("action", data.type);
    formData.append("remarks", data?.remarks || "");
    // formData.append("unit_price", data.unit_price);
    formData.append("qty", data.stock);
    // formData.append("beginning_inventory", data.beginning_inventory);

    const response = await postAPICallwithFile(
      process.env.REACT_APP_LINK + "inventories/update",
      formData
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
export const deleteItem = async (inventory_id) => {
  try {
    const response = await postAPICall(
      process.env.REACT_APP_LINK + "inventories/delete",
      {
        requester: getUser(),
        token: getToken(),
        inventory_id,
      }
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
